import OrderMethod from './order-method';
import DeliveryAddress from './delivery-address';
import Location from './location';
import Login from './login';
import DateTime from './date-time';
import SignUp from './sign-up';
import HelpAndFaq from './help-and-faq';
import LanguageSwitcher from './language-switcher';
import OrderTracker from './order-tracker';

export default {
  OrderMethod,
  DeliveryAddress,
  Location,
  Login,
  DateTime,
  SignUp,
  HelpAndFaq,
  LanguageSwitcher,
  OrderTracker,
};
